import React, { useEffect, useRef, useState } from "react";
import {
  book_video_call_temp_web,
  book_video_call_temp_mobile,
  comingsoonbanner,
  RightArrow,
  SHARE_IC,
  wishlist_icon,
  dagabengalurulogoPNG,
  CLOSE_BLACK_IC,
} from "../../../assets";
import DagaProductCard from "../../Master/DagaProductCard";
import Breadcrumbs from "../../Utilities/BreadCrumbs/Breadcrumbs";
import BTN from "../../Master/BTN";
import { useParams } from "react-router-dom";
import {
  useAddToCustomerBagMutation,
  useGetProductDataQuery,
  useAddToWishlistMutation,
  useRemoveFromWishlistMutation,
} from "../../../redux/slices/homeSlice";
import LazyImageLoader from "../../Master/LazyImageLoader";
import useGetUser from "../../../hooks/useGetUser";
import { useDispatch, useSelector } from "react-redux";
import { addToMyBag } from "../../../redux/slices/myBagSlice";
import { toast } from "react-toastify";
import ReactImageMagnify from "react-image-magnify";
import ZoomImage from "./ZoomImage";
import Skeleton from "react-loading-skeleton";

const DagaProductPage = () => {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "products", link: "/search" },
  ];

  const ref = React.useRef(null);
  const [products, setProducts] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  const [imageModelToggle, setImageModelToggle] = useState(false);
  const [bookDemoModel, setBookDemoModel] = useState(false);
  const modelRef = useRef(null);
  const bookDemoModelRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modelRef.current && !modelRef.current.contains(event.target)) {
      setImageModelToggle(false);
    }
  };

  const handleClickOutsideBookDemo = (event) => {
    if (
      bookDemoModelRef.current &&
      !bookDemoModelRef.current.contains(event.target)
    ) {
      setBookDemoModel(false);
    }
  };

  useEffect(() => {
    fetch("https://fakestoreapi.com/products/category/jewelery")
      .then((res) => res.json())
      .then((json) => {
        setProducts(json);
        setIsLoaded(true);
        console.log(json);
      });
  }, []);

  const { id } = useParams();
  const {
    data: productData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
  } = useGetProductDataQuery({ id: id });
  console.log(productData);
  const user = useGetUser();
  const [loggedIn, setLoggedIn] = useState(false);
  const [addToCustomerBag] = useAddToCustomerBagMutation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (user?.customer) {
      setLoggedIn(true);
    }
  }, [user]);

  const addToMyBagHandel = () => {
    if (loggedIn) {
      addToCustomerBag({
        body: {
          products: [
            {
              product_id: productData?.product?._id,
              quantity: 1,
              variant: [],
              lens: [],
            },
          ],
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          toast.success(
            `${productData?.product?.name} added to bag successfully.`
          );
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    } else {
      dispatch(addToMyBag(productData?.product));
      toast.success(`${productData?.product?.name} added to bag successfully.`);
    }
  };

  const [wishListed, setWishListed] = useState(false);
  const wishlistData = useSelector((state) => state.wishlist.data);
  useEffect(() => {
    if (wishlistData) {
      if (productData?.product._id) {
        const found = wishlistData?.find(
          (element) => element._id === productData.product._id
        );
        if (found) {
          setWishListed(true);
        } else {
          setWishListed(false);
        }
      }
    }
  }, [wishlistData, productData]);

  const [addToWishlist] = useAddToWishlistMutation();
  const [removeFromWishlist] = useRemoveFromWishlistMutation();
  const handleWishlist = () => {
    if (!wishListed) {
      if (!loggedIn) {
        toast.error("Please log in to add into Wishlist");
        return;
      }
      if (!productData.product._id) {
        return;
      }
      addToWishlist({
        body: {
          product_id: productData.product._id,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res.data) {
          setWishListed(true);
          toast.success("Added to Wishlist");
        }
        if (res.error) {
          toast.error(res.error.data.message);
        }
      });
    } else {
      removeFromWishlist({
        body: {
          product_id: productData.product._id,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res.data) {
          setWishListed(false);
          toast.success("Removed from Wishlist");
        }
        if (res.error) {
          toast.error(res.error.data.message);
        }
      });
    }
  };

  // const [bgExist, setBgExist] = useState(true);
  // const handleBgTrue = (data) => {
  //   setBgExist(data);
  // };

  // ======= TRY ON =======

  useEffect(() => {
    unm();
  }, []);
  function unm() {
    const tryOnFrame = document.getElementById("iframe-container");
    //alert(tryOnFrame)
    if (tryOnFrame != null || tryOnFrame != undefined) {
      tryOnFrame.remove();
    }
  }
  useEffect(() => {
    // alert(tryon)
    setTimeout(() => {
      unm();
      try {
        const JeweltryFun = Window.myConstructor;
        const JeweltryConstructor = new JeweltryFun(
          process.env.REACT_APP_TRY_ON_SECRET_KEY,
          productData?.product?.sku
        );
        JeweltryConstructor.init();
      } catch (err) {
        console.log(err);
      }
    }, 1000);
    //  unm()
    return () => {
      unm();
    };
  }, [productData?.product?.sku]);

  return (
    <div>
      <div className="">
        <div className="pl-4">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        {/* <div className="grid grid-rows-1 md:grid-cols-[55%_45%] gap-4 "> */}
        <div className="flex flex-col md:grid md:grid-cols-[55%_45%] gap-4">
          <div className="object-contain relative">
            {/* <ReactImageMagnify
              {...{
                smallImage: {
                  alt: "",
                  isFluidWidth: true,
                  src: `${
                    productData?.product?.image?.[0]?.replace(
                      /^http:/,
                      "https:"
                    ) || dagabengalurulogoPNG
                  }`,
                  srcSet: `${
                    productData?.product?.image?.[0]?.replace(
                      /^http:/,
                      "https:"
                    ) || dagabengalurulogoPNG
                  }`,
                },
                largeImage: {
                  src: `${
                    productData?.product?.image?.[0]?.replace(
                      /^http:/,
                      "https:"
                    ) || dagabengalurulogoPNG
                  }`,
                  // width: 1426,
                  // height: 2000,
                  width: 926,
                  height: 1500,
                },
              }}
              className="relative "
              imageClassName="aspect-[7/5] w-full h-full object-contain p-8"
              enlargedImageClassName="aspect-[7/5] object-contain"
              enlargedImageContainerClassName="bg-white border border-light_secondary"
              enlargedImagePosition="over"
            /> */}
            <LazyImageLoader
              onClick={() => setImageModelToggle(true)}
              imgClassName={
                "aspect-[7/5] w-full h-full object-contain p-4 lg:p-8 cursor-pointer"
              }
              imgSrc={
                productData?.product?.image?.[0]?.replace(
                  "upload/",
                  "upload/f_auto/fl_progressive/if_w_gt_1200/w_1200/if_end/"
                ) || dagabengalurulogoPNG
              }
            />
            {/* <img
              src={
                productData?.product?.image?.[0]?.replace(/^http:/, "https:") ||
                dagabengalurulogoPNG
              }
              alt=""
              className="aspect-[7/5] w-full h-full object-contain p-8"
            /> */}
          </div>
          {/* <div className="object-contain relative">
              <ZoomImage srcImage={productData?.product?.image?.[0]} />
            </div> */}
          <div className="py-4 pl-4 pr-4 md:pr-8 md:overflow-y-scroll no-scrollbar aspect-[7/5] h-auto md:h-full w-full">
            {/* <div>
              <span className="text-text_dark_3 ">
                ( MRP inclusive of all taxes)
              </span>
              <div className=" text-primary text-2xl font-bold">
                <span>&#8377; </span>
                <span>
                  {productData?.product?.prices?.price || (
                    <Skeleton count={1} className="max-w-[15%]" />
                  )}
                </span>
              </div>
            </div> */}
            <div className="">
              <div className="text-text_dark_4  font-semibold mb-2 lato-semibold">
                SKU &nbsp;
                <span>
                  {productData?.product?.sku || (
                    <Skeleton count={1} className="max-w-[15%]" />
                  )}
                </span>
              </div>
              <div className="text-primary font-bold mb-2 lato-bold">
                {productData?.product?.name || (
                  <Skeleton count={1} className="max-w-[50%]" />
                )}
              </div>
              <div className="text-text_dark_2">
                {productData?.product?.description?.en === undefined ? (
                  <Skeleton count={1} className="max-w-[70%] lato-regular" />
                ) : productData?.product?.description?.en.trim() !== "" ? (
                  productData.product.description.en
                ) : (
                  ""
                )}
              </div>
            </div>

            <div></div>
            {/* <div className="flex flex-row gap-4 mt-16 flex-grow">
              <BTN
                onP={addToMyBagHandel}
                title={
                  productData?.product?.stock <= 0
                    ? "ORDER TO MAKE"
                    : "ADD TO CART"
                }
                bordered
                className="lato-regular py-2 px-4 flex justify-center flex-shrink border-[1px] border-primary bg-primary text-text_light_3 rounded-lg"
                // to={"/profile-details#order-history"}
              />

              <div
                className="border-[1px] border-primary rounded-lg p-2 cursor-pointer"
                onClick={handleWishlist}
              >
                {wishListed ? (
                  <svg
                    className="pointer h-[35px] w-[35px] object-contain p-1"
                    viewBox="0 -960 960 960"
                    fill="#5D0D19"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="min-w-fit max-w-fit min-h-fit max-h-fit"
                      d="M 480 -173.85 L 449.69 -201.23 C 384.41 -260.87 330.41 -311.92 287.69 -354.38 C 244.977 -396.847 211.26 -434.297 186.54 -466.73 C 161.82 -499.163 144.55 -528.51 134.73 -554.77 C 124.91 -581.023 120 -607.433 120 -634 C 120 -684.873 137.283 -727.59 171.85 -762.15 C 206.41 -796.717 249.127 -814 300 -814 C 335.18 -814 368.18 -805 399 -787 C 429.82 -769 456.82 -742.82 480 -708.46 C 503.18 -742.82 530.18 -769 561 -787 C 591.82 -805 624.82 -814 660 -814 C 710.873 -814 753.59 -796.717 788.15 -762.15 C 822.717 -727.59 840 -684.873 840 -634 C 840 -607.433 835.09 -581.023 825.27 -554.77 C 815.45 -528.51 798.18 -499.163 773.46 -466.73 C 748.74 -434.297 715.15 -396.847 672.69 -354.38 C 630.23 -311.92 576.103 -260.87 510.31 -201.23 L 480 -173.85 Z M 480 -501 Z"
                      transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
                    />
                  </svg>
                ) : (
                  <svg
                    className="pointer h-[35px] w-[35px] object-contain p-1"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#5D0D19"
                  >
                    <path
                      className="min-w-fit max-w-fit min-h-fit max-h-fit"
                      d="m480-173.85-30.31-27.38q-97.92-89.46-162-153.15-64.07-63.7-101.15-112.35-37.08-48.65-51.81-88.04Q120-594.15 120-634q0-76.31 51.85-128.15Q223.69-814 300-814q52.77 0 99 27t81 78.54Q514.77-760 561-787q46.23-27 99-27 76.31 0 128.15 51.85Q840-710.31 840-634q0 39.85-14.73 79.23-14.73 39.39-51.81 88.04-37.08 48.65-100.77 112.35Q609-290.69 510.31-201.23L480-173.85Zm0-54.15q96-86.77 158-148.65 62-61.89 98-107.39t50-80.61q14-35.12 14-69.35 0-60-40-100t-100-40q-47.77 0-88.15 27.27-40.39 27.27-72.31 82.11h-39.08q-32.69-55.61-72.69-82.5Q347.77-774 300-774q-59.23 0-99.62 40Q160-694 160-634q0 34.23 14 69.35 14 35.11 50 80.61t98 107q62 61.5 158 149.04Zm0-273Z"
                    />
                  </svg>
                )}
              </div>
              <a
                href={`https://api.whatsapp.com/send?text=have a look at this design by daga gems : ${encodeURIComponent(
                  window.location.href
                )}`}
                target="_blank"
              >
                <button className="border-[1px] border-primary rounded-lg p-2">
                  <img
                    className="min-w-[30px] h-[30px] object-cover"
                    src={SHARE_IC}
                    alt="Wishlist"
                  />
                </button>
              </a>
            </div> */}
            <div className="bg-bg_1 rounded-2xl flex  flex-col lg:flex-row mt-14">
              <div className="aspect-square hidden lg:flex">
                <img
                  src={book_video_call_temp_web}
                  className="h-full w-full object-cover"
                  alt=""
                />
              </div>
              <div className="aspect-auto lg:hidden flex">
                <img
                  src={book_video_call_temp_mobile}
                  className="h-full w-full object-cover"
                  alt=""
                />
              </div>
              <div className="lg:p-4 p-2 flex flex-col lg:gap-4 gap-2">
                <div className="font-bold cormorant-bold">
                  Live Video Shopping
                </div>
                <div className="text-text_dark_4 text-sm md:w-[85%] lato-regular">
                  Join a live video call with our consultant to see your
                  favourite designs up close!
                </div>
                <div className="flex flex-wrap items-center">
                  <BTN
                    onP={() => setBookDemoModel(true)}
                    title="BOOK VIDEO CALL"
                    bordered
                    className="py-2 lato-regular px-4 w-fit border-[1px] border-primary bg-transparent text-primary text-sm rounded-lg"
                  />
                  <div
                    aria-label="Try On"
                    id="jeweltry-button"
                    className="hidden lg:ms-0 xl:ms-3 ms-3 mt-0 lg:mt-1 xl:mt-0 rounded-lg text-nowrap whitespace-normal lato-regular w-fit py-2 px-4 bg-primary uppercase cursor-pointer text-white text-center "
                  >
                    Try Now
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-16">
              <div className="right_bottom_div ">
                <div className="checkout_card_main ">
                  {(productData?.product?.grossWeight !== 0 ||
                    productData?.product?.netWeight !== 0) && (
                    <div className="flex justify-between border-b-2 border-dashed border-text_medium mb-4">
                      <span className="text-text_dark_2 font-semibold mb-4">
                        Product Details
                      </span>
                    </div>
                  )}
                  {/* -------------------Default by mapping jewellry's array for attribute value ------------------- */}
                  {/* {productData?.product?.attributes?.[0]?.Jewellery?.map(
                    (item, index) => (
                      <div key={index} className="flex justify-between mb-2">
                        <span className="text-text_dark_4 font-semibold">
                          {item?.attributeName || (
                            <Skeleton count={1} className="max-w-[20%]" />
                          )}
                        </span>
                        <span className="text-text_dark font-semibold">
                          {item?.attributeValue || (
                            <Skeleton count={1} className="max-w-[10%]" />
                          )}
                        </span>
                      </div>
                    )
                  )} */}
                  {/* -------------------Dynamic with title and key & value pair------------------- */}
                  {productData?.product?.attributes &&
                    productData?.product?.attributes?.map(
                      (attributeGroup, groupIndex) =>
                        Object.entries(attributeGroup)?.map(
                          ([groupKey, attributes]) => (
                            <div key={groupIndex} className="mb-4">
                              {/* Attribute Group Title */}
                              <h3 className="text-lg font-semibold text-primary mb-2">
                                {groupKey}
                              </h3>

                              {/* Attribute Items */}
                              {Array.isArray(attributes) &&
                                attributes?.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex justify-between mb-2"
                                  >
                                    <span className="text-text_dark_4 font-semibold lato-semibold">
                                      {item?.attributeName || (
                                        <Skeleton
                                          count={1}
                                          className="max-w-[10%]"
                                        />
                                      )}
                                    </span>
                                    <span className="text-text_dark font-semibold lato-semibold">
                                      {item?.attributeValue || (
                                        <Skeleton
                                          count={1}
                                          className="max-w-[10%]"
                                        />
                                      )}
                                    </span>
                                  </div>
                                ))}
                            </div>
                          )
                        )
                    )}

                  {/* -------------------------------------- */}
                  {productData?.product?.netWeight !== 0 && (
                    <div className="flex justify-between mb-2">
                      <span className="text-text_dark_4 font-semibold lato-semibold">
                        Net Weight
                      </span>
                      <span className="text-text_dark font-semibold lato-semibold">
                        {productData?.product?.netWeight + "g" || (
                          <Skeleton count={1} className="max-w-[20%]" />
                        )}
                      </span>
                    </div>
                  )}
                  {productData?.product?.grossWeight !== 0 && (
                    <div className="flex justify-between mb-2">
                      <span className="text-text_dark_4 font-semibold lato-semibold">
                        Gross Weight
                      </span>
                      <span className="text-text_dark font-semibold lato-semibold">
                        {productData?.product?.grossWeight + "g" || (
                          <Skeleton count={1} className="max-w-[20%]" />
                        )}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {productData?.product?.relatedProducts?.length > 0 && (
          <div className="bg-bg_1 pt-10 pb-10 mb-16">
            <div className="text-primary text-4xl text-center pb-10 tracking-[2.65px] cormorant-bold">
              SIMILAR PRODUCTS
            </div>
            <div className="p-4">
              <div
                ref={ref}
                className="grid justify-start grid-flow-col gap-4 overflow-scroll no-scrollbar"
              >
                {!isLoaded &&
                  [{}, {}, {}, {}].map((item, index) => (
                    <div className="w-[40vw] sm:w-[23.5vw]" key={index}>
                      <DagaProductCard key={index} />
                    </div>
                  ))}
                {productData?.product?.relatedProducts?.map((item, index) => (
                  <div className="w-[40vw] sm:w-[23.5vw]" key={index}>
                    {/* <ProductCard 
              product={item} 
                  /> */}
                    <DagaProductCard
                      key={index}
                      img={item?.image[0]}
                      price={item?.price}
                      title={item?.title?.en}
                      link={`/products/${item?._id}`}
                    />
                  </div>
                ))}
              </div>
              <div className="flex gap-4 justify-center mt-16">
                <img
                  src={RightArrow}
                  alt="our store"
                  className="border-[1px] border-primary rounded-full p-2 px-5 text-primary cursor-pointer rotate-180"
                  onClick={() => {
                    ref.current.scroll({
                      left: ref.current.scrollLeft - 500,
                      behavior: "smooth",
                    });
                  }}
                />
                <img
                  src={RightArrow}
                  alt="our store"
                  className="border-[1px] border-primary rounded-full p-2 px-5 text-primary cursor-pointer"
                  onClick={() => {
                    ref.current.scroll({
                      left: ref.current.scrollLeft + 500,
                      behavior: "smooth",
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {/* ==================== IMAGE PREVIEW MODEL =============== */}
      {imageModelToggle && (
        <>
          <div
            onClick={handleClickOutside}
            className="fixed left-0 top-0 z-9999 flex h-full min-h-screen w-full items-center justify-center bg-black/50 px-4 py-5"
          >
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="absolute right-2 top-2 bg-white rounded-full p-2 cursor-pointer"
              onClick={() => setImageModelToggle(false)}
            />
            <div
              ref={modelRef}
              className={`small:w-[95%] md:w-[95%] lg:w-[60%] bg-white border-0 overflow-visible relative flex flex-col outline-none focus:outline-none`}
            >
              <LazyImageLoader
                imgClassName={
                  "aspect-auto md:aspect-[10/8] w-auto h-auto object-cover"
                }
                imgSrc={
                  productData?.product?.image?.[0]?.replace(
                    "upload/",
                    "upload/f_auto/fl_progressive/if_w_gt_1200/w_1200/if_end/"
                  ) || dagabengalurulogoPNG
                }
              />
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-999 bg-black"></div>
        </>
      )}
      {/* ==================== BOOK VIDEO CALL MODEL =============== */}
      {bookDemoModel && (
        <>
          <div
            onClick={handleClickOutsideBookDemo}
            className="fixed left-0 top-0 z-9999 flex h-full min-h-screen w-full items-center justify-center bg-black/50 px-4 py-5"
          >
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="absolute right-2 top-2 bg-white rounded-full p-2 cursor-pointer"
              onClick={() => setBookDemoModel(false)}
            />
            <div
              ref={bookDemoModelRef}
              className={`small:w-[95%] md:w-[95%] lg:w-[60%] bg-white border-0 overflow-visible relative flex flex-col outline-none focus:outline-none`}
            >
              <iframe
                className={`w-full flex items-center justify-center h-[80vh]`}
                src="https://calendar.plushvie.in/daga/30min?duration=30"
              ></iframe>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-999 bg-black"></div>
        </>
      )}
    </div>
  );
};

export default DagaProductPage;
